/*
 Export intercom id:s for elements to be targeted by
 */
export const INTERCOM_IDS = {
  MAIN_MENU_USER: "main-menu-user",
  MAIN_MENU_ALERTS: "main-nav-link-alerts",
  MAIN_MENU_ALERT_SETTINGS: "main-nav-active-alert-settings",
  MAIN_MENU_EXPLORE: "main-nav-link-explore",
  MAIN_MENU_REPORTS: "main-nav-link-analytics",
  MAIN_MENU_TAGS: "main-nav-link-tags",
  MAIN_MENU_ARCHIVE: "main-nav-link-archive",
  MAIN_MENU_FAVORITES: "main-nav-link-favorites",
  MAIN_MENU_CREATE_NEW: "main-nav-link-new-alert",
};

export const INTERCOM_ARTICLES = {
  PREVIEW_RESULTS: "15460410",
  REACH: "3765637",
  PR_VALUE: "3765736",
  TOPICS_DEPRECATION: "16897853",
};

export const INTERCOM_SURVEYS = {
  FEEDBACK_EN: "64920374",
  FEEDBACK_SV: "64922506",
};
